import { gql, TypedDocumentNode } from '@common/hooks';

type InputValuesType = {
  firstName?: string;
  lastName?: string;
  phone?: string;
  timeZone?: string;
  saveLastVisitedPage?: boolean | null;
};

type UpdateCurrentWorksUserDetailsMutationResponseType = {
  updateCurrentWorksUserDetails: {
    currentWorksUser: {
      id: string;
      saveLastVisitedPage: boolean | null;
    };
  };
};

export type UpdateCurrentWorksUserDetailsMutationVariablesType = {
  input: InputValuesType;
};

export const UpdateCurrentWorksUserDetailsMutation: TypedDocumentNode<
  UpdateCurrentWorksUserDetailsMutationResponseType,
  UpdateCurrentWorksUserDetailsMutationVariablesType
> = gql`
  mutation UpdateCurrentWorksUserDetails(
    $input: UpdateCurrentWorksUserDetailsInput!
  ) {
    updateCurrentWorksUserDetails(input: $input) {
      currentWorksUser {
        id
        saveLastVisitedPage
      }
    }
  }
`;
